import ContainerMobile from './ContainerMobile';

export default ContainerMobile;
